var React = require('react');
var ReactNative = require('react-native');


var Animated = require('./wrappers/Animated')

var Icon = require('./wrappers/ReUpIcon');

var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var QRCodeView = require('./QRCodeView.js');
var ReUpButton = require('./ReUpButton.js');
var MKSegmentControl = require('./MKSegmentControl.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var NetworkManager = require('./NetworkManager');
var CheckMarkView = require('./CheckMarkView');
var FadingView = require('./FadingView');
var {PhysScene, PhysObject} = require('./PhysScene');

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKSpinner
} = MK;

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
  StyleSheet,
  Vibration,
  Platform,
  TouchableWithoutFeedback,
} = ReactNative;

function getBase64Data(data)
{
  var dataJsonString = JSON.stringify(data);
  var dataBase64 = btoa(dataJsonString);

  return dataBase64;
}

var CheckIn = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      dollarsPerPoint : 1,
    }
  },

  componentDidMount : function()
  {
    this.setQRCode();
    var appManager = this.props.appManager;
    if( appManager.isLoggedIn() )
    {
      this._pointsAdded = appManager.currentUser()[ModelConstants.TotalPointsAddedAtScanner];
      this._points = appManager.currentUser()[ModelConstants.Points];
      this._credit = appManager.currentUser()[ModelConstants.Credits];
      this._hash = appManager.currentUser()[ModelConstants.Hash];
    }
    this.queuePoll();
  },

  componentWillUnmount : function()
  {
    if( this._pollTimeout != null ) clearTimeout(this._pollTimeout);
  },

  _hash : null,
  _pollTimeout : null,
  _isFirstPoll : true,
  queuePoll : function()
  {
    var appManager = this.props.appManager;
    var thisThing = this;
    this._pollTimeout = setTimeout(()=>
    {
      if( appManager.isLoggedIn() )
      {
        NetworkManager.updateFeature( appManager, "User", (user)=>
        {
          if( typeof user !== 'undefined' && user != null && typeof user[ModelConstants.Hash] !== 'undefined' )
          {
            var newHash = user[ModelConstants.Hash];
            var newPointsAdded = user.TotalPointsAddedAtScanner;
            var newCredit = user[ModelConstants.Credits];
            var newPoints = user[ModelConstants.Points];
            if( newCredit != thisThing._credit || newPoints != thisThing._points || newHash != thisThing._hash || newPointsAdded != thisThing._pointsAdded )
            {
              appManager.setCurrentUser(user, ()=>
              {
                if( newPointsAdded > thisThing._pointsAdded && !thisThing._isFirstPoll ) thisThing.announceTransaction(0, newPointsAdded - thisThing._pointsAdded);
                thisThing._pointsAdded = newPointsAdded;
                thisThing._credit = newCredit;
                thisThing._points = newPoints;
                thisThing._hash = newHash;
                thisThing.setQRCode();
                thisThing.forceUpdate();
              });
            }
          }
          thisThing._isFirstPoll = false;
          thisThing.queuePoll();
        }, ()=>
        {
          thisThing.queuePoll();
        })
      }
      else
      {
        thisThing.queuePoll();
      }
    }, appManager._isDemo ? 20000 : 5000);
  },

  setQRCode : function()
  {
    var appManager = this.props.appManager;
    var user = appManager.currentUser();
    var qrData = {};
    this._hash = user[ModelConstants.Hash];
    qrData["Type"] = "checkin";
    qrData["AppID"] = appManager.getAppInfo()["appid"];
    qrData["U"] = user[ModelConstants.UserID];
    qrData["H"] = user[ModelConstants.Hash];

    var qrDataBase64 = getBase64Data(qrData);

    if( this._ref_qrcode ) this._ref_qrcode.setData(qrDataBase64);
  },

  didUpdate : function(data)
  {
    if( typeof data.Campaigns !== 'undefined' )
    {
      var checkInCampaign = null;
      for( var i = 0; i < data.Campaigns.length; i++ )
      {
        var campaign = data.Campaigns[i];
        if( campaign.Type == "Checkin" || campaign.Type == "CheckIn" ) checkInCampaign = JSON.parse(campaign.CampaignBlob);
      }

      this.setState({
        dollarsPerPoint:checkInCampaign == null ? null : checkInCampaign.DollarsPerPoint,
      });
    }
  },

  announceTransaction : function(deltaCredit, deltaPoints)
  {
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();

    var message = "";
    if( deltaCredit > 0 && deltaPoints > 0 )
    {
      message = locManager.localizedStringForKeyAndParams("USER_WITHDREW_EARNED_STATEMENT",
        [locManager.localizedDollars(deltaCredit), locManager.localizedPoints(deltaPoints)],
        "You spent %0% and earned %1%.");
    }
    else if( deltaCredit < 0 )
    {
      message = locManager.localizedStringForKeyAndParams("USER_WITHDREW_STATEMENT",
        [locManager.localizedDollars(-deltaCredit)]);
    }
    else if( deltaPoints > 0 )
    {
      message = locManager.localizedStringForKeyAndParams("USER_EARNED_STATEMENT",
        [locManager.localizedPoints(deltaPoints)]);
    }

    var pattern, patternLiteral, patternDescription;
    if (Platform.OS === 'android')
    {
      pattern = [0,2000];
    }
    else
    {
      pattern = [0];
    }
    Vibration.vibrate(pattern)

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var objBG = 'transparent';//appManager.getColorForKey("FeedCardBannerColor");
    var objFG = appManager.getColorForKey("ButtonPrimaryColor");//appManager.getColorForKey("FeedCardBannerIconColor");

    var MAX_OBJECTS = 10;
    var numObjects = Math.abs(deltaPoints);
    while(numObjects > MAX_OBJECTS) numObjects /= 2;

    var renderObject = ()=>{ return <View style={{width:40, height:40, borderRadius:20, backgroundColor:objBG, alignItems:'center', flexDirection:'row', justifyContent:'center'}} ><Icon name={"trophy"} size={40} color={objFG} style={{backgroundColor:'transparent'}} /></View>};
    var objects = [];
    for( var i = 0; i < numObjects; i++ )
    {
      var imod = i%4;
      var velX = (imod == 0 || imod == 1 ? -1 : 1 ) * (0.0005 + 0.0001 * Math.random());
      // var velY = (imod == 0 || imod == 3 ? -1 : 1 ) * (0.0005 + 0.0001 * Math.random());
      var velY = -0.001 + -0.002 * Math.random();
      var startTime = 300+(i+1)*100;
      objects.push({
        posX:.5, posY:.5, velX, velY, renderObject, startTime
      })
    }
    var thisThing = this;
    thisThing._doneButtonFadingView = null;
    setTimeout(()=>
    {
      if( thisThing._doneButtonFadingView ) thisThing._doneButtonFadingView.setFadedOut(false);
    }, 3000)
    // setTimeout(()=>
    // {
    //   if( thisThing.state.renderAlternative )
    //   {
    //     thisThing.setState({renderAlternative:false});
    //     setTimeout(()=>
    //     {
    //       thisThing.setQRCode();
    //     }, 200)
    //   }
    // }, 10000)
    this.setState({
      renderAlternative:true,
      renderAlternativeView:()=>
        <View style={{backgroundColor:generalColor, flexDirection:'column', alignItems:'center', justifyContent:'center', width:this.state.layout.width, height:this.state.layout.height}}>
        {
          false ?
            <PhysScene
              style={{position:'absolute', top:0, left:0, width:this.state.layout.width, height:this.state.layout.height}}
              objectInfos={objects}/>
          : null
        }
          <View style={{marginHorizontal:20, borderRadius:8, flexDirection:'column', alignItems:'center'}}>
            <View style={{width:100, height:100, flexDirection:'column', marginBottom:20}}>
              <CheckMarkView color={appManager.getColorForKey("FeedCardBannerColor")} style={{flex:1, alignSelf:'stretch'}} />
            </View>
            <ReUpText isTitle={true} appManager={appManager} style={{color:appManager.getColorForKey("FeedCardTitleColor"), backgroundColor:appManager.getColorForKey("FeedCardColor",.6), textAlign:'center'}}>
            {message}
            </ReUpText>
          </View>
          <FadingView ref={(a) => { thisThing._doneButtonFadingView = a }} animDuration={200} style={{height:50, marginHorizontal:20, marginTop:40, alignSelf:'stretch'}}>
            <ReUpButton appManager={appManager} text={locManager.localizedStringForKey("DONE_BUTTON", "Done")} />
          </FadingView>
          <TouchableWithoutFeedback style={{position:'absolute', left:0, right:0, top:0, bottom:0}} onPress={()=>
            {
              thisThing.setState({renderAlternative:false});
              setTimeout(()=>
              {
                thisThing.setQRCode();
              }, 200)
            }} >
            <View style={{position:'absolute', left:0, right:0, top:0, bottom:0}} />
          </TouchableWithoutFeedback>
        </View>
    })
  },

  render: function()
  {
    var addCredit = this;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

    var pointsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");

    var dimension = Math.min(this.state.layout.width-100, this.state.layout.height-164);
    var localizedDollarsPerPoint = locManager.localizedDollars(this.state.dollarsPerPoint);
    var instructions = "";
    if( this.state.dollarsPerPoint != null )
    {
      instructions = locManager.localizedStringForKeyAndParams("EARN_POINTS_DESCRIPTION", [locManager.localizedPoints((1/this.state.dollarsPerPoint).toFixed(1)), locManager.localizedDollars(1)]);
    }
    var borderRadius = typeof this.props.extras !== 'undefined' && typeof this.props.extras.borderRadius !== 'undefined' ? this.props.extras.borderRadius : 0;
    var isEmptyString = locManager.localizedStringForKey("CHECK_IN_DISABLED_STATEMENT", "You can currently only earn points when you pay with your app.");
    var isEmpty = this.state.dollarsPerPoint == null;
    var alertMessage = locManager.localizedStringForKeyAndParams(this.props.featureData.instructions, [locManager.localizedPoints((1/this.state.dollarsPerPoint).toFixed(1)), locManager.localizedDollars(1)]);

    return (
      <View style={styles.container}
        onLayout={(event)=>this.setState({containerLayout:event.nativeEvent.layout})}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} />}
        <View style={[styles.backgroundView, {backgroundColor: generalColor, borderRadius}]} />

        <ReUpScrollView ref={(c) => { this._ref_ptr = c; }} bounces={true} responder={this} featureName="CheckIn" isEmpty={isEmpty} isEmptyPostfix={isEmptyString}
          renderAlternative={this.state.renderAlternative} renderAlternativeView={this.state.renderAlternativeView}>
        {
          !isEmpty ?
            <View style={{flexDirection:'row', flex:-1}}>
              <View style={{height:this.state.layout.height}} />
              <View style={{flexDirection:'column', flex:1}}>
                <View style={{flex:1}}>
                  <View style={[styles.instructionContainer, {backgroundColor: instructionColor, color:instructionTitleColor}]}>
                    <View style={{alignSelf:'center', flex:1}}>
                      <ReUpText appManager={appManager} style={[styles.instructionText, {color:instructionTitleColor}]}>
                        {instructions}
                      </ReUpText>
                    </View>
                    <ReUpIconButton type={3}
                      appManager={appManager}
                      featureData={this.props.featureData}
                      locParams={[localizedDollarsPerPoint]}
                      appActions={this.props.appActions}
                      alertMessage={alertMessage}
                      />
                  </View>
                  <ShadowView appManager={appManager} layout={this.state.layout} />
                  <View style={{flex:1}} />
                </View>
                <QRCodeView ref={(c) => { this._ref_qrcode = c; }} key="qrcode" data={""} dimension={dimension} style={styles.qrcode} spinnerView={<MKSpinner style={{alignSelf : 'center',backgroundColor : 'transparent'}} strokeColor={[generalTitleColor]} />} />
                <View style={{flex:1}} />
              </View>
            </View>
          : null
        }
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
    alignSelf:'stretch',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    backgroundColor:'blue',
    flexDirection:'row',
    flex:-1
  },
  instructionText: {
    margin:10,
  },
  tipText: {
    alignSelf: 'center'
  },
  backgroundView: {
    position: 'absolute',
    top:0, left:0, right:0, bottom:0,
  },
  qrcode: {
    padding: 30,
    alignItems:'center',
  },
  tipContainer: {
    height:50,
    flex:1,
    padding:10,
  },
  tipTypeContainer: {
    height:50,
    width:180,
    alignSelf:'center'
  },
  textField: {
    width:120,
    height:50,
    marginTop:10
  },
  button: {
    justifyContent:'center',
    flex:1,
  },
  tipValueContainer: {
    paddingTop:4,
    paddingLeft:20,
    paddingRight:20,
    alignItems:'center',
    justifyContent:'center',
    flexDirection:'row',
  },
  tipLabel: {
    paddingLeft:8,
    paddingRight:8,
    textAlign:'center',
    alignSelf:'flex-end',
  }
});

CheckIn.dataDependencies = ["Users", "Campaigns"];

module.exports = CheckIn;
